import React, { useMemo } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
} from '@mui/material';
import { SalesRecordingAggregateStatus, SalesRecordingTotals } from '@marageti/z4-sdk/lib/travel/SalesRecording';
import { useNavigate } from 'react-router-dom';
import { StatusChip } from '../utils';

type Props = {
  sales: SalesRecordingTotals[],
  selectedMonth: Date | null;
};

type Row = {
  partner: string;
  status: SalesRecordingAggregateStatus;
  partnerInvoiceDetailUrl: string | null;
};

const InvoiceTable = ({
  sales,
  selectedMonth,
}: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const rows: Row[] = useMemo(() => (sales.map((sale) => {
    const partnerInvoiceDetailUrl = `/sales/invoices/${sale.partnerId}`;
    return {
      partner: sale.partnerName || sale.partnerId,
      status: sale.aggregateStatus,
      partnerInvoiceDetailUrl,
    };
  })), [sales]);

  const handleRowClick = (row: Row) => () => {
    if (row.partnerInvoiceDetailUrl) {
      navigate(row.partnerInvoiceDetailUrl, { state: { selectedMonth } });
    }
  };

  return (
    <TableContainer sx={{ marginTop: '0px !important' }}>
      <Table sx={{ width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell align="left">Partner</TableCell>
            <TableCell align="left" sx={{ display: 'flex', justifyContent: 'flex-end' }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              hover
              key={row.partner}
              onClick={handleRowClick(row)}
              sx={{
                cursor: 'pointer',
                width: '100%',
              }}
            >
              <TableCell sx={{ fontFamily: 'captionBold', color: theme.palette.common.black, fontWeight: 700 }} align="left">{row.partner}</TableCell>
              <TableCell sx={{ fontFamily: 'captionBold', display: 'flex', justifyContent: 'flex-end' }} align="left">
                <StatusChip status={row.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTable;
